import axios from 'axios'
import config from '../config'

// Shared guard to ensure Chapter VI-A deductions do not exceed Gross Total Income
// prospectiveOverrides: { incomeFromSalary?: number, incomeFromHP?: number, incomeFromOtherSources?: number }
export const validateDeductionsVsGrossForProspectiveUpdate = async (prospectiveOverrides = {}) => {
  try {
    const pan = localStorage.getItem('PAN_NO')
    const year = localStorage.getItem('YEAR')
    if (!pan || !year) return { ok: true } // do not block if we cannot validate

    // Fetch current computation (OLD regime) to get baseline incomes
    const compRes = await axios.get(`${config.apiUrl}/user/tax-computation/${pan}/${year}/OLD`)
    const tc = compRes.data?.taxComputation || {}

    const incomeFromSalary = Number(
      prospectiveOverrides.incomeFromSalary !== undefined
        ? prospectiveOverrides.incomeFromSalary
        : tc.incomeFromSalary || 0,
    )
    const incomeFromHP = Number(
      prospectiveOverrides.incomeFromHP !== undefined
        ? prospectiveOverrides.incomeFromHP
        : tc.incomeFromHP || 0,
    )
    const incomeFromOtherSources = Number(
      prospectiveOverrides.incomeFromOtherSources !== undefined
        ? prospectiveOverrides.incomeFromOtherSources
        : tc.incomeFromOtherSources || 0,
    )

    const prospectiveGross = incomeFromSalary + incomeFromHP + incomeFromOtherSources

    // Fetch current deduction totals from server
    const dedRes = await axios.get(`${config.apiUrl}/deduction/${pan}/${year}`)
    const deduction = dedRes.data?.deduction || {}

    // Try multiple fields to obtain total deduction
    const serverTotal = Number(
      deduction.totalDeduction ??
      deduction?.deductionUndChapVIAType?.totalChapVIADeductions ?? 0,
    )

    const ok = serverTotal <= prospectiveGross
    return { ok, prospectiveGross, serverTotal }
  } catch (e) {
    // Fail-open to avoid blocking legitimate saves if API is transiently unavailable
    return { ok: true }
  }
}

export const exceedDeductionErrorMessage =
  'Deduction cannot exceed Gross total income (Salary, House Property & Other Sources)'


